import JsonError from './JsonError';

export default class UnauthorizedApiError extends JsonError {}
